import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Authenticator } from '@aws-amplify/ui-react';
import { Box } from '@mui/material';
import logo from 'src/assets/logo/Envirally_final_logo_blue-02.svg';
import { Provider } from 'react-redux';
import { store } from './modules/redux/store/store';

document.title = 'Envirally - Admin';

const components = {
    Header() {
        return (
            <Box
                className="text-center"
                style={{
                    marginTop: '5%',
                    marginBottom: '5%',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <img
                    src={logo}
                    className="envirally-logo"
                    alt="envirally logo"
                    style={{ width: '50%' }}
                />
            </Box>
        );
    },
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <Authenticator loginMechanisms={['email']} components={components}>
                <App />
            </Authenticator>
        </Provider>
    </React.StrictMode>
);

reportWebVitals();
